import { setBank, setSupportedCurrencies } from 'store/slices/currency'
import { Bank, Currency } from 'types'
import { emptySplitApi } from './emptySplit.api'

// Define a service using a base URL and expected endpoints
export const banksApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBanks: builder.query<{ banks: Bank[] }, void>({
      query: () => ({
        url: 'banks',
        method: 'GET',
        responseHandler: (response) => response.json(),
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          dispatch(setBank(data.banks))
        } catch (err) {
          // `onError` side-effect
        }
      },
    }),
  }),
  overrideExisting: false,
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBanksQuery } = banksApi
